import { gql } from '@apollo/client';
import { DriverAddressInput } from '../assignDrivers';

export const LIST_ROUTE_PLANNING_TEMPLATES = gql`
    query ListRoutePlanningTemplates($areaId: Long!, $warehouseId: Long!) {
        listRoutePlanningTemplates(areaId: $areaId, warehouseId: $warehouseId) {
            id
            name
            assignType
            isDefault
            driverCount
            details {
                id
                driverAccountId
                driverName
                capacityMin
                capacityMax
                preferredZipcodes
                startAddress {
                    streetAddress
                    city
                    state
                    zipCode
                    latitude
                    longitude
                }
                endAddress {
                    streetAddress
                    city
                    state
                    zipCode
                    latitude
                    longitude
                }
            }
        }
    }
`;

export interface RoutePlanningTemplateDetailOutput {
    id?: number | null;
    driverAccountId?: number | null;
    driverName?: string | null;
    capacityMin?: number | null;
    capacityMax?: number | null;
    preferredZipcodes: string[];
    startAddress?: DriverAddressInput | null;
    endAddress?: DriverAddressInput | null;
}

export interface RoutePlanningTemplateOutput {
    id: number;
    name: string;
    assignType: number;
    isDefault: boolean;
    driverCount: number;
    details: RoutePlanningTemplateDetailOutput[];
}

export interface ListRoutePlanningTemplatesResponse {
    listRoutePlanningTemplates: RoutePlanningTemplateOutput[];
}

export interface ListRoutePlanningTemplatesVariables {
    areaId: number;
    warehouseId: number;
}
